<template>
  <div
    id="background"
    :style="[
      { backgroundSize: 'cover', width: `${width}px`, height: `${height}px`, position: 'relative'},
      backgroundImageUrl ? {'backgroundImage': 'url(' + backgroundImageUrl + ')'} : {},
    ]"
  >
    <div id="items" style="padding: 0;">
      <v-layout
        v-for="field in fields"
        :key="field.id"
        :style="getStyles(field.parentStyles, true)"
        :class="['parent-container', {
          'builder-avatar': field.avatar,
          'builder-flag': field.flag,
          'builder-oval': field.oval,
          'builder-image': field.image,
          'builder-qr-code': field.qrCode,
          'builder-barcode': field.barcode,
        }]"
        align-center
      >
        <v-flex v-if="field.parentStyles.backgroundImage">
          <img
            :style="getStyles(field.childStyles, true)"
            style="width: 100%;"
            :src="field.parentStyles.backgroundImage || field.childStyles.backgroundImage"
          >
        </v-flex>
        <v-flex
          v-else
          :id="field.id"
          :style="getStyles(field.childStyles)"
        >
          <span v-if="field.asHtml" :id="`field-${field.id}`" class="field" v-html="field.data" />
          <span v-else :id="`field-${field.id}`" class="field"> {{ field.data }} </span>
        </v-flex>
      </v-layout>
    </div>
  </div>
</template>

<script>

import { toCSS } from './../../utils'
import { itemToAccreditationField } from './builder.utils'

import fitty from 'fitty'

export default {
  name: 'preview',
  props: {
    items: Array,
    backgroundImageUrl: String,
    accreditation: Object,
    height: Number,
    width: Number,
    attendeeFields: Array,
  },
  data() {
    return {
      fields: [],
    }
  },
  async mounted() {
    this.fields = await this.updateFields()
    this.$nextTick(() => {
      this.fitText()
      if (this.backgroundImageUrl) {
        const backgroundImage = new Image()
        backgroundImage.src = this.backgroundImageUrl
        backgroundImage.onload = this.waitForImages
      } else {
        this.waitForImages()
      }
    })
  },
  methods: {
    waitForImages() {
      const imgCount = this.fields.reduce((acc, field) => field.parentStyles.backgroundImage ? ++acc : acc, 0)
      if (imgCount === 0)
        return this.$emit('on-ready')
      const queryImages = () => document.querySelectorAll('img')
      const interval = setInterval(() => {
        let images = queryImages()
        if (images.length === imgCount) {
          if (![...images].some(e => !e.complete)) {
            clearInterval(interval)
            this.$emit('on-ready')
          }
        }
      }, 10)
    },
    getStyles(styles, noBackground = false) {
      const cssStyles = toCSS(styles)
      if (noBackground)
        delete cssStyles['background-image']

      return cssStyles
    },
    async updateFields() {
      return Promise.all(this.items.map(item => itemToAccreditationField(item, this.accreditation, this.attendeeFields)))
    },
    fitText() {
      const fields = document.querySelectorAll('.field')
      Array.from(fields).forEach(node => {
        if (node.parentElement.offsetWidth < node.offsetWidth) {
          fitty(node)
        }
      })
    },
  },
}
</script>

<style scoped>
  .parent-container {
    position: absolute;
    margin: 0px 0px !important;
  }
  .field {
    line-height: 1.2;
    display: block;
  }
</style>
